import type { RuleGraphNode } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";

/**
 * The card's prominent body line, from the typed meta the graph generators
 * emit — `condition` (MATCHING), `sortKey` (SORTED BY), `limit` (UP TO n
 * products) — falling back to the summary sentence. Meta is validated
 * defensively: a malformed value falls through rather than crashing the
 * canvas.
 */
export const nodeBodyText = (node: RuleGraphNode): string | undefined => {
  const meta = node.meta;
  if (node.kind === "filter" && typeof meta?.condition === "string") {
    return meta.condition;
  }
  if (node.kind === "sort" && typeof meta?.sortKey === "string") {
    return meta.sortKey;
  }
  if (
    node.kind === "limit" &&
    typeof meta?.limit === "number" &&
    Number.isFinite(meta.limit)
  ) {
    return `${meta.limit} product${meta.limit === 1 ? "" : "s"}`;
  }
  return undefined;
};
